export default __webpack_public_path__ + "static/media/tigo-01.0d836b63.png";